import React from 'react'
import { Container, YStack } from '@mythical/ui'
import { Meta } from 'app/components/primitive/Meta'
import SubscriptionPanel, {
  Perk,
  tiersList,
} from 'app/components/primitive/SubscriptionPanel'
import MainLayout from 'app/components/structure/Layout/MainLayout'
import Section from 'app/components/structure/Section'
import SectionIntroLarge from 'app/components/structure/SectionIntro/SectionIntroLarge'
import { createParam } from 'solito'
import useQuery from 'app/hooks/use-query'
import { createTiersQuery, mapToTiers } from 'app/queries/tiers/member-tiers'
import { useStores } from 'app/store'
import { observer } from 'mobx-react-lite'
import { createPerksQuery, mapPerks } from 'app/queries/perks/perks'
import Spinner from 'app/components/primitive/Spinner'

const query = createTiersQuery()
const perksQuery = createPerksQuery()

const params = {}
const { useParam } = createParam()

export const PerksScreen = observer(() => {
  const [tier] = useParam('tier')
  const { userStore } = useStores()
  const { data, loading: tiersLoading } = useQuery(query, params, mapToTiers)
  const { data: perksData, loading: perksLoading } = useQuery(
    perksQuery,
    params,
    mapPerks
  )

  const hasTierParam = tier && Number.isInteger(Number(tier))
  const tierUp = hasTierParam
    ? Number(tier)
    : tiersList.findIndex((tier) => tier === userStore?.user?.tier) + 1

  const loading = tiersLoading || perksLoading

  return (
    <MainLayout
      noSidebar
      noFooter={false}
      noBottomTabs
      showBackBtn
      contentStyles={{
        maxWidth: 1024,
        mx: 'auto',
        w: '100%',
        mb: '$5',
        minWidth: 'auto',
        borderWidth: 1,
        borderColor: '$primary10',
      }}
    >
      <Meta title="Perks" slug="perks" />
      <SectionIntroLarge
        title="Perks of the Mythical Society"
        bg="$secondary9"
      />

      <Section padded bg="$secondary10" space="$3">
        <Container>
          {loading && (
            <YStack py="$3.5" w="100%" jc="center">
              <Spinner size='large' />
            </YStack>
          )}
          {!loading && (
            <SubscriptionPanel
              perks={perksData as Perk[]}
              memberTiers={data}
              initialLevel={tiersList.length > tierUp ? tierUp : 3}
            />
          )}
        </Container>
      </Section>
    </MainLayout>
  )
})
